/**
 * Линейный график с заливкой под кривой.
 *
 * Жил внутри AdminAnalyticsPage. Информационной панели он нужен тоже,
 * а копия означала бы два графика, которые со временем разъедутся.
 *
 * Доступность: svg получает роль img и текстовое описание — скринридер
 * читает диапазон и максимум вместо молчания на «картинке».
 */
export function LineChart({
  data,
  valueKey,
  color = 'var(--accent)',
  height = 100,
  label = 'График',
  formatValue = (v) => v,
}) {
  if (!data?.length) return null

  const W = 320
  const H = height
  const padX = 4
  const padY = 14

  const values = data.map((d) => d[valueKey] || 0)
  const maxV = Math.max(...values, 1)

  const points = data.map((d, i) => ({
    x: padX + (i / Math.max(1, data.length - 1)) * (W - padX * 2),
    y: H - padY - ((d[valueKey] || 0) / maxV) * (H - padY * 2),
    val: d[valueKey] || 0,
    label: d.date,
  }))

  const path = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ')
  const last = points[points.length - 1]
  const area = `${path} L ${last.x} ${H - padY} L ${points[0].x} ${H - padY} Z`

  const summary =
    `${label}: ${data.length} точек, максимум ${formatValue(maxV)}, ` +
    `последнее значение ${formatValue(last.val)}`

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      className="line-chart"
      role="img"
      aria-label={summary}
    >
      <path d={area} fill={color} opacity="0.14" />
      <path
        d={path}
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {points.map((p, i) => (
        <circle key={i} cx={p.x} cy={p.y} r={2.5} fill={color}>
          <title>
            {p.label}: {formatValue(p.val)}
          </title>
        </circle>
      ))}
    </svg>
  )
}
